// eslint-disable-next-line
Date.prototype.getFullMinutes = function () {
   if (this.getMinutes() < 10) {
       return '0' + this.getMinutes();
   }
   return this.getMinutes();
};

// eslint-disable-next-line
Date.prototype.getAMPM = function () {
  return this.getHours() >= 12 ? "PM" : "AM";
};

// eslint-disable-next-line
Date.prototype.getDayWordAbr = function () {
  var days = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];
  return days[this.getDay()];
}

// eslint-disable-next-line
Date.prototype.getDayWord = function () {
  var days = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
  return days[this.getDay()];
}

// eslint-disable-next-line
Date.prototype.getMonthAbr = function () {
  var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  return months[this.getMonth()];
}

// eslint-disable-next-line
Date.prototype.formatTime = function () {
  return this.getHours() + ":" + this.getFullMinutes() + " " + this.getAMPM();
}

// eslint-disable-next-line
Date.prototype.formatDayDateMonth = function () {
  return this.getDayWordAbr() +", " + this.getDate() + " " + this.getMonthAbr()
}


// eslint-disable-next-line
Date.prototype.hhmmtt = function () {
  const hours = this.getHours();
  var minutes = this.getMinutes();
  minutes = minutes>9?minutes:"0" + minutes;
  return hours>12?(hours - 12) + ":" + minutes + " pm":hours + ":" + minutes + " am"
}

export function FormatDayDateMonthTime(dateTime) {
  var d = new Date(dateTime);
  return d.formatDayDateMonth() + " " + d.formatTime();
  //console.log("FormatDayDateMonthTime: " + d.format("D"));
  //return "AAA";
}

export function FormatDate_ddd_MMM_d_yyyy(dateTime) {
  var d = new Date(dateTime);
  return d.getDayWordAbr() + ", " + d.getDate() + " " + d.getMonthAbr() + ", " + d.getFullYear();
}

export function FormatDate_MMM_d_yyyy(dateTime) {
  var d = new Date(dateTime);
  return d.getDate() + " " + d.getMonthAbr() + ", " + d.getFullYear();
}

export function FormatTimeRange_h_mm(startDateTime, stopDateTime) {
  var d1 = new Date(startDateTime);
  var d2 = new Date(stopDateTime);

  return d1.formatTime() + " - " + d2.formatTime();
}




/*
http://www.csharp-examples.net/string-format-datetime/

ddd, MMM d, yyyy   = Sun, Mar 9, 2018

*/



// WEBPACK FOOTER //
// ./src/lib/DateTimeFormatFunctions.js